import { API } from "@/main";

const state = {
  token: localStorage.getItem("auth_token"),
  company: localStorage.getItem("company_name"),
};

const getters = {};

const mutations = {};

const actions = {
  SEND_RECOVERY_EMAIL({ commit }, email) {
    return new Promise((resolve, reject) => {
      API.emailRecovery.postEmail(
        email,
        (result) => {
          resolve(result.data);
        },
        (error) => {
          reject(error);
        }
      );
    });
  },
  RESET_PASSWORD({ commit }, password) {
    return new Promise((resolve, reject) => {
      API.emailRecovery.resetPassword(
        password,
        (result) => {
          resolve(result.data);
        },
        (error) => {
          reject(error);
        }
      );
    });
  },
};

export default { state, getters, actions, mutations };



// WEBPACK FOOTER //
// ./src/store/modules/emailRecovery.js